import React, { useState } from "react";
import { Button } from "../../components/ui/button";
import { ArrowRight } from "lucide-react";
import { useTheme } from "./theme-provider";
import CalendlyModal from "../../components/CalendlyModal";

export default function HeroSection() {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);
  
  return (
    <section id="hero" className={`py-20 md:py-28 relative overflow-hidden ${
      isDarkMode ? 'bg-gradient-to-b from-gray-950 to-gray-900' : ''
    }`}>
      {/* Dark mode specific background effects */}
      {isDarkMode && (
        <>
          <div className="absolute top-0 right-0 w-full h-[500px] bg-gradient-to-b from-purple-900/10 to-transparent opacity-50 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-900/10 rounded-full opacity-70 blur-3xl"></div>
        </>
      )}
      
      <div className="container px-4 md:px-6 relative z-10">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-12 items-center">
          <div className="flex flex-col justify-center space-y-4">
            <div className="space-y-6">
              <h1 className={`text-4xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl text-balance ${
                isDarkMode ? 'text-white' : ''
              }`}>
                Your Website Is Your Online Office. <br /> Staff It With <br /><span className="bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 text-transparent bg-clip-text">SmushChat <br />Assistant</span>
              </h1>
              <p className={`max-w-[600px] ${
                isDarkMode ? 'text-gray-300' : 'text-gray-600'
              } md:text-xl/relaxed lg:text-base/relaxed xl:text-l`}>
                80% of customer queries could be solved with documentation, but nobody likes reading it. Our AI Assistant
                guides them to exactly what they need, and helps them navigate your digital space just like a receptionist in your physical office.
              </p>
              <br />
            </div>
            <div className="flex flex-col gap-2 min-[400px]:flex-row">
              <Button size="lg" className={`gap-1.5 ${
                isDarkMode ? 'bg-purple-600 hover:bg-purple-700 text-white' : ''
              }`} onClick={() => window.location.href = '/get-started'}>
                Build you Agent
                <ArrowRight className="h-4 w-4" />
              </Button>
              <Button size="lg" variant="outline" className={
                isDarkMode ? 'border-gray-700 text-gray-200 hover:bg-gray-800 hover:text-white' : ''
              } onClick={() => setIsCalendlyOpen(true)}>
                Book a demo
              </Button>
            </div>
            <div className="flex items-center space-x-4 text-sm">
              <div className="flex -space-x-2">
                {[
                  "/Clients/favicon-32x32 (1).png",
                  "/Clients/Favicon-100x100.webp",
                  "/Clients/favicon.jpg",
                  "/Clients/favicon-32x32.png",
                  "/Clients/background-32x32.webp",
                ].map((img, i) => (
                  <div
                    key={i}
                    className="h-6 w-6 rounded-full border-2 border-gray-200 overflow-hidden bg-white ring-1 ring-gray-200"
                  >
                    <img src={img} alt={`Client ${i+1}`} className="h-full w-full object-cover rounded-full" />
                  </div>
                ))}
              </div>
              <div className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'} md:text-s/relaxed`}>
                <span className="font-medium">Powering Industry Leaders</span>
              </div>
            </div>
          </div>
            <div className={`relative h-[350px] w-full sm:h-[400px] md:h-[450px] lg:h-[500px] ${
              isDarkMode ? 'bg-gradient-to-br from-gray-900/50 to-gray-800/50 p-4 rounded-xl' : ''
            }`}>
              <img
                src="https://cdn.prod.website-files.com/6643307d563d3d1613330141/664475ee0685539e4d230fbd_Group%201116602035.svg"
                alt="StreamLine Dashboard"
                className={`object-contain w-full h-full ${
                  isDarkMode ? 'drop-shadow-[0_0_15px_rgba(168,85,247,0.2)]' : ''
                }`}
              />
            </div>
          </div>
      </div>
      
      {/* Calendly Modal */}
      <CalendlyModal 
        isOpen={isCalendlyOpen}
        onClose={() => setIsCalendlyOpen(false)}
      />
    </section>
  );
} 